const viewTypes = [ 'None', 'Transacting', 'Monitoring'];

export default function ValidationRules(order, pkg) {
  if (order && order.orderType === 'Programmatic') {
    return {
      agencyPlacementName: {
        required: { msg: 'Agency Placement Name is required' },
        maxLength: { msg: 'Name must be no more than 255 characters', value: 255 }
      },
      StrategyId: {
        required: { msg: 'Strategy is required' }
      },
      SalesProductId: {
        required: { msg: 'Sales Product is required' }
      },
      CreativeProducts: {
        required: { msg: 'Creative Products are required' }
      },
      DeviceTypes: {
        required: { msg: 'At least one Device Type is required' }
      },
      ioRate: {
        required: { msg: 'IO Rate is required' },
        numeric: { msg: 'IO Rate must be a numeric value' }
      },
      IoRateTypeId: {
        required: { msg: 'IO Rate Type is required' }
      },
      targetLanguage: {
        required: { msg: 'Target Language is required' }
      },
      contractedQuantity: {
        required: { msg: 'Contracted Quantity is required' },
        numeric: { msg: 'Contracted Quantity must be a numeric value' },
        minVal: { msg: 'Contracted Quantity must be 1 or more', value: 1 }
      },
      comments: {
        maxLength: { msg: 'Comments must be no more than 255 characters', value: 255 }
      }
    }
  }
  if (pkg) {
    return {
      agencyPlacementName: {
        required: { msg: 'Agency Placement Name is required' },
        maxLength: { msg: 'Name must be no more than 255 characters', value: 255 }
      },
      agencyPlacementId: {
        required: { msg: 'Agency Placement ID is required' },
        maxLength: { msg: 'ID must be no more than 255 characters', value: 255 }
      },
      agencyBillingId: {
        required: { msg: 'Billing ID is required' },
        maxLength: { msg: 'Billing ID must be no more than 255 characters', value: 255 }
      },
      StrategyId: {
        required: { msg: 'Strategy is required' }
      },
      SalesProductId: {
        required: { msg: 'Sales Product is required' }
      },
      CreativeProducts: {
        required: { msg: 'Creative Products are required' }
      },
      DeviceTypes: {
        required: { msg: 'At least one Device Type is required' }
      },
      targetLanguage: {
        required: { msg: 'Target Language is required' }
      },
      viewability: {
        required: { msg: 'Viewability is required' },
        oneOf: { options: viewTypes, msg: 'Viewability not one of compatible types' }
      },
      comments: {
        maxLength: { msg: 'Comments must be no more than 255 characters', value: 255 }
      }
    }
  }
  if (order && (order.IoStatusId === 1 || order.IoStatusId === 2)) {
    return {
      agencyPlacementName: {
        required: { msg: 'Agency Placement Name is required' },
        maxLength: { msg: 'Name must be no more than 255 characters', value: 255 }
      },
      StrategyId: {
        required: { msg: 'Strategy is required' }
      },
      SalesProductId: {
        required: { msg: 'Sales Product is required' }
      },
      CreativeProducts: {
        required: { msg: 'Creative Products are required' }
      },
      DeviceTypes: {
        required: { msg: 'At least one Device Type is required' }
      },
      comments: {
        maxLength: { msg: 'Comments must be no more than 255 characters', value: 255 }
      }
    }
  }
  if (order && order.IoStatusId === 3) {
    return {
      agencyPlacementName: {
        required: { msg: 'Agency Placement Name is required' },
        maxLength: { msg: 'Name must be no more than 255 characters', value: 255 }
      },
      StrategyId: {
        required: { msg: 'Strategy is required' }
      },
      SalesProductId: {
        required: { msg: 'Sales Product is required' }
      },
      CreativeProducts: {
        required: { msg: 'Creative Products are required' }
      },
      DeviceTypes: {
        required: { msg: 'At least one Device Type is required' }
      },
      ioRate: {
        required: { msg: 'IO Rate is required' },
        numeric: { msg: 'IO Rate must be a numeric value' }
      },
      IoRateTypeId: {
        required: { msg: 'IO Rate Type is required' }
      },
      contractedQuantity: {
        required: { msg: 'Contracted Quantity is required' },
        numeric: { msg: 'Contracted Quantity must be a numeric value' },
        minVal: { msg: 'Contracted Quantity must be 1 or more', value: 1 }
      },
      viewability: {
        required: { msg: 'Viewability is required' },
        oneOf: { options: viewTypes, msg: 'Viewability not one of compatible types' }
      },
      comments: {
        maxLength: { msg: 'Comments must be no more than 255 characters', value: 255 }
      }
    }
  }
  return {
    agencyPlacementName: {
      required: { msg: 'Agency Placement Name is required' },
      maxLength: { msg: 'Name must be no more than 255 characters', value: 255 }
    },
    agencyPlacementId: {
      required: { msg: 'Agency Placement ID is required' },
      maxLength: { msg: 'ID must be no more than 255 characters', value: 255 }
    },
    agencyBillingId: {
      required: { msg: 'Billing ID is required' },
      maxLength: { msg: 'Billing ID must be no more than 255 characters', value: 255 }
    },
    StrategyId: {
      required: { msg: 'Strategy is required' }
    },
    SalesProductId: {
      required: { msg: 'Sales Product is required' }
    },
    CreativeProducts: {
      required: { msg: 'Creative Products are required' }
    },
    DeviceTypes: {
      required: { msg: 'At least one Device Type is required' }
    },
    ioRate: {
      required: { msg: 'IO Rate is required' },
      numeric: { msg: 'IO Rate must be a numeric value' }
    },
    IoRateTypeId: {
      required: { msg: 'IO Rate Type is required' }
    },
    contractedQuantity: {
      required: { msg: 'Contracted Quantity is required' },
      numeric: { msg: 'Contracted Quantity must be a numeric value' },
      minVal: { msg: 'Contracted Quantity must be 1 or more', value: 1 }
    },
    targetLanguage: {
      required: { msg: 'Target Language is required' }
    },
    viewability: {
      required: { msg: 'Viewability is required' },
      oneOf: { options: viewTypes, msg: 'Viewability not one of compatible types' }
    },
    comments: {
      maxLength: { msg: 'Comments must be no more than 255 characters', value: 255 }
    }
  }
};
